// This object should contain a mock value for each required prop of this component
export const requiredProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    },
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      items: [
        {
          title: 'First Row With Button',
          children: 'text',
          buttonType: 'button',
          expandLabel: 'Show More',
          collapseLabel: 'Less',
        },
        {
          title: 'Second Row With Icon',
          children: 'text',
          expandLabel: 'Show More',
          collapseLabel: 'Less',
        },
      ],
    },
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
